<div class="uk-container uk-container-expand">
  <div class="uk-grid uk-margin-medium-bottom">
    <div class="uk-width-1-1 uk-margin-small-bottom">
      <h2 class="titre-demandes">Mes Demandes d'Encadrement</h2>
    </div>
  </div>

  <ng-container *ngIf="!isLoaded; else displayContent">
    <lib-ags-loading></lib-ags-loading>
  </ng-container>

  <ng-template #displayContent>
    <ng-container *ngIf="demandes.length; else noDemande">
      <div class="uk-grid uk-grid-match uk-margin-remove-left">
        <ng-container *ngFor="let demande of demandes; index as i">
          <ng-container *ngIf="!!demande">
            <div class="uk-width-1-4@xl uk-width-1-3@l uk-width-1-2@m uk-margin-remove uk-padding-remove">
              <div class="uk-card uk-card-default" style="margin: 0 1rem 1rem 0">
                <div class="uk-card-header uk-padding-small" [ngClass]="[headerBackground]">
                  <div class="uk-grid-small uk-flex-middle">
                    <div class="uk-width-expand">
                      <h3 class="uk-card-title uk-margin-remove-bottom" [ngClass]="[headerColor]">Proposition</h3>
                      <p class="uk-text-meta uk-margin-remove-top uk-margin-remove-bottom" [ngClass]="[headerColor]">
                        <ng-container *ngIf="demande.dateValid; else dateValidUnavailable">
                          Valable jusqu'au {{ demande.dateValid }}
                        </ng-container>
                        <ng-template #dateValidUnavailable>
                          Date de validité non trouvée
                        </ng-template>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="uk-card-body uk-padding-small">
                  <ng-container *ngIf="demande.title || demande.referenceProduit; else titleUnavailable">
                    <p>{{ demande.title || 'Titre non trouvé' }} - {{ demande.referenceProduit || '' }}</p>
                  </ng-container>
                  <ng-template #titleUnavailable>
                    <p>Titre et référence produit non trouvé</p>
                  </ng-template>
                  <ng-container
                    *ngIf="demande.referenceInterne || demande.referenceSession; else referencesUnavailable"
                  >
                    <p>
                      <ng-container *ngIf="demande.referenceInterne">
                        {{ demande.referenceInterne }}<br />
                      </ng-container>

                      <ng-container *ngIf="demande.referenceSession; else referenceSessionUnavailable">
                        Session {{ demande.referenceSession || '' }}
                      </ng-container>
                      <ng-template #referenceSessionUnavailable>
                        Référence session non trouvé
                      </ng-template>
                    </p>
                  </ng-container>
                  <ng-template #referencesUnavailable>
                    <p>Références internes et produit non trouvé</p>
                  </ng-template>
                  <ng-container *ngIf="demande.dateBegin; else dateBeginUnavailable">
                    <p>
                      <i class="material-icons" style="vertical-align: middle; margin-right: 3px">
                        calendar_today
                      </i>
                      <span style="vertical-align: middle">Début le {{ demande.dateBegin }}</span>
                    </p>
                  </ng-container>
                  <ng-template #dateBeginUnavailable>
                    <p>
                      <i class="material-icons" style="vertical-align: middle; margin-right: 3px">
                        calendar_today
                      </i>
                      <span style="vertical-align: middle">Date de début non trouvé</span>
                    </p>
                  </ng-template>
                  <ng-container *ngIf="demande.dateEnd; else dateEndUnavailable">
                    <p>
                      <i class="material-icons" style="vertical-align: middle; margin-right: 3px">
                        calendar_today
                      </i>
                      <span style="vertical-align: middle">Fin le {{ demande.dateEnd }}</span>
                    </p>
                  </ng-container>
                  <ng-template #dateEndUnavailable>
                    <p>
                      <i class="material-icons" style="vertical-align: middle; margin-right: 3px">
                        calendar_today
                      </i>
                      <span style="vertical-align: middle">Date de fin non trouvé</span>
                    </p>
                  </ng-template>
                  <ng-container *ngIf="demande.lieuName || demande.lieuAddress; else lieuUnavailable">
                    <p>
                      <i class="material-icons" style="vertical-align: middle; margin-right: 3px">
                        room
                      </i>
                      <span style="vertical-align: middle">{{ demande.lieuName }}</span
                      ><br />
                      <span style="vertical-align: middle; margin-left: 27px; display:block; height: 100%;">{{
                        demande.lieuAddress
                      }}</span>
                    </p>
                  </ng-container>
                  <ng-template #lieuUnavailable>
                    <p>
                      <i class="material-icons" style="vertical-align: middle">
                        room
                      </i>
                      Lieu non trouvé
                    </p>
                  </ng-template>
                  <p>Responsable administratif : {{ demande.nameResponsible || ' - ' }}</p>
                  <p style="text-align: center">
                    <button
                      kendoButton
                      [primary]="true"
                      class="k-button k-primary"
                      (click)="seeDetails(i)"
                    >
                      Voir détails
                    </button>
                  </p>
                  <p class="uk-text-center" style="margin-bottom: .3rem;">
                    <button
                      kendoButton
                      class="k-button k-primary"
                      style="margin-left: .2rem; margin-right: .3rem;"
                      [primary]="false"
                      (click)="refuse(i)"
                    >
                      <span uk-icon="close"></span>&nbsp;Je décline
                    </button>
                    <button
                      kendoButton
                      class="k-button k-primary"
                      style="margin-left: .2rem; margin-right: .3rem;"
                      [primary]="true"
                      (click)="accept(i)"
                    >
                      <span uk-icon="check"></span>&nbsp;J'accepte
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </ng-container>

    <ng-template #noDemande>
      <div class="uk-tile uk-tile-muted">
        <p class="uk-h4 uk-text-center">Vous n'avez aucune demande d’encadrement</p>
      </div>
    </ng-template>
  </ng-template>
</div>
